/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Tracking_Status_No_ChangeInputs */

const tr_geliver_tracking_status_no_change = /** @type {(inputs: Geliver_Tracking_Status_No_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durum güncel, değişiklik yok`)
};

const en_geliver_tracking_status_no_change = /** @type {(inputs: Geliver_Tracking_Status_No_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status current, no changes`)
};

const de_geliver_tracking_status_no_change = /** @type {(inputs: Geliver_Tracking_Status_No_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status aktuell, keine Änderungen`)
};

const ru_geliver_tracking_status_no_change = /** @type {(inputs: Geliver_Tracking_Status_No_ChangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Статус актуален, изменений нет`)
};

/**
* | output |
* | --- |
* | "Status current, no changes" |
*
* @param {Geliver_Tracking_Status_No_ChangeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_tracking_status_no_change = /** @type {((inputs?: Geliver_Tracking_Status_No_ChangeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Tracking_Status_No_ChangeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_tracking_status_no_change(inputs)
	if (locale === "de") return de_geliver_tracking_status_no_change(inputs)
	if (locale === "ru") return ru_geliver_tracking_status_no_change(inputs)
	return tr_geliver_tracking_status_no_change(inputs)
});